import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppUpdateProvider } from './contexts/AppUpdateContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PrivateRoute } from './components/PrivateRoute';
import { LoginPage } from './pages/LoginPage';
import { LandingPage } from './pages/LandingPage';
import { AdminPage } from './pages/AdminPage';
import { ContactsPage } from './pages/ContactsPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { DealsPage } from './pages/DealsPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppUpdateProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route
                path="/app"
                element={
                  <PrivateRoute>
                    <LandingPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <PrivateRoute>
                    <AdminPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/contacts"
                element={
                  <PrivateRoute requireAppAccess>
                    <ContactsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/contacts/:contactId"
                element={
                  <PrivateRoute requireAppAccess>
                    <ContactsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/companies"
                element={
                  <PrivateRoute requireAppAccess>
                    <CompaniesPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/companies/:companyId"
                element={
                  <PrivateRoute requireAppAccess>
                    <CompaniesPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/deals"
                element={
                  <PrivateRoute requireAppAccess>
                    <DealsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/deals/:dealId"
                element={
                  <PrivateRoute requireAppAccess>
                    <DealsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute requireAppAccess>
                    <ReportsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute requireAppAccess>
                    <SettingsPage />
                  </PrivateRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AppUpdateProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
